/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { gisUserLayerGetCitiesGet } from '../fn/user-layer/gis-user-layer-get-cities-get';
import { GisUserLayerGetCitiesGet$Params } from '../fn/user-layer/gis-user-layer-get-cities-get';
import { gisUserLayerGetDocumentInfoPost } from '../fn/user-layer/gis-user-layer-get-document-info-post';
import { GisUserLayerGetDocumentInfoPost$Params } from '../fn/user-layer/gis-user-layer-get-document-info-post';
import { gisUserLayerGetLayersInfoGet } from '../fn/user-layer/gis-user-layer-get-layers-info-get';
import { GisUserLayerGetLayersInfoGet$Params } from '../fn/user-layer/gis-user-layer-get-layers-info-get';
import { gisUserLayerGetProvincesGet } from '../fn/user-layer/gis-user-layer-get-provinces-get';
import { GisUserLayerGetProvincesGet$Params } from '../fn/user-layer/gis-user-layer-get-provinces-get';
import { gisUserLayerInsertDataToElasticsearchGet } from '../fn/user-layer/gis-user-layer-insert-data-to-elasticsearch-get';
import { GisUserLayerInsertDataToElasticsearchGet$Params } from '../fn/user-layer/gis-user-layer-insert-data-to-elasticsearch-get';
import { gisUserLayerInsertUserLayersInfoToElasticsearchGet } from '../fn/user-layer/gis-user-layer-insert-user-layers-info-to-elasticsearch-get';
import { GisUserLayerInsertUserLayersInfoToElasticsearchGet$Params } from '../fn/user-layer/gis-user-layer-insert-user-layers-info-to-elasticsearch-get';
import { gisUserLayerSearchPost } from '../fn/user-layer/gis-user-layer-search-post';
import { GisUserLayerSearchPost$Params } from '../fn/user-layer/gis-user-layer-search-post';

@Injectable({ providedIn: 'root' })
export class UserLayerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `gisUserLayerInsertDataToElasticsearchGet()` */
  static readonly GisUserLayerInsertDataToElasticsearchGetPath = '/gis/UserLayer/InsertDataToElasticsearch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gisUserLayerInsertDataToElasticsearchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerInsertDataToElasticsearchGet$Response(params?: GisUserLayerInsertDataToElasticsearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gisUserLayerInsertDataToElasticsearchGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gisUserLayerInsertDataToElasticsearchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerInsertDataToElasticsearchGet(params?: GisUserLayerInsertDataToElasticsearchGet$Params, context?: HttpContext): Observable<void> {
    return this.gisUserLayerInsertDataToElasticsearchGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gisUserLayerInsertUserLayersInfoToElasticsearchGet()` */
  static readonly GisUserLayerInsertUserLayersInfoToElasticsearchGetPath = '/gis/UserLayer/InsertUserLayersInfoToElasticsearch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gisUserLayerInsertUserLayersInfoToElasticsearchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerInsertUserLayersInfoToElasticsearchGet$Response(params?: GisUserLayerInsertUserLayersInfoToElasticsearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gisUserLayerInsertUserLayersInfoToElasticsearchGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gisUserLayerInsertUserLayersInfoToElasticsearchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerInsertUserLayersInfoToElasticsearchGet(params?: GisUserLayerInsertUserLayersInfoToElasticsearchGet$Params, context?: HttpContext): Observable<void> {
    return this.gisUserLayerInsertUserLayersInfoToElasticsearchGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gisUserLayerGetLayersInfoGet()` */
  static readonly GisUserLayerGetLayersInfoGetPath = '/gis/UserLayer/GetLayersInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gisUserLayerGetLayersInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerGetLayersInfoGet$Response(params?: GisUserLayerGetLayersInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gisUserLayerGetLayersInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gisUserLayerGetLayersInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerGetLayersInfoGet(params?: GisUserLayerGetLayersInfoGet$Params, context?: HttpContext): Observable<void> {
    return this.gisUserLayerGetLayersInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gisUserLayerSearchPost()` */
  static readonly GisUserLayerSearchPostPath = '/gis/UserLayer/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gisUserLayerSearchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  gisUserLayerSearchPost$Response(params?: GisUserLayerSearchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gisUserLayerSearchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gisUserLayerSearchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  gisUserLayerSearchPost(params?: GisUserLayerSearchPost$Params, context?: HttpContext): Observable<void> {
    return this.gisUserLayerSearchPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gisUserLayerGetDocumentInfoPost()` */
  static readonly GisUserLayerGetDocumentInfoPostPath = '/gis/UserLayer/GetDocumentInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gisUserLayerGetDocumentInfoPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  gisUserLayerGetDocumentInfoPost$Response(params?: GisUserLayerGetDocumentInfoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gisUserLayerGetDocumentInfoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gisUserLayerGetDocumentInfoPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  gisUserLayerGetDocumentInfoPost(params?: GisUserLayerGetDocumentInfoPost$Params, context?: HttpContext): Observable<void> {
    return this.gisUserLayerGetDocumentInfoPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gisUserLayerGetProvincesGet()` */
  static readonly GisUserLayerGetProvincesGetPath = '/gis/UserLayer/GetProvinces';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gisUserLayerGetProvincesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerGetProvincesGet$Response(params?: GisUserLayerGetProvincesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gisUserLayerGetProvincesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gisUserLayerGetProvincesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerGetProvincesGet(params?: GisUserLayerGetProvincesGet$Params, context?: HttpContext): Observable<void> {
    return this.gisUserLayerGetProvincesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gisUserLayerGetCitiesGet()` */
  static readonly GisUserLayerGetCitiesGetPath = '/gis/UserLayer/GetCities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gisUserLayerGetCitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerGetCitiesGet$Response(params?: GisUserLayerGetCitiesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gisUserLayerGetCitiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gisUserLayerGetCitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gisUserLayerGetCitiesGet(params?: GisUserLayerGetCitiesGet$Params, context?: HttpContext): Observable<void> {
    return this.gisUserLayerGetCitiesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
